import api from '@/api';

export default {
  namespaced: true,
  state     : {
    planTab : 0,
    planTabs: [
      {
        title: 'Календарь планирования',
      },
      {
        title: 'Заявки на обучение',
      },
    ],
    disabledDates : [],
    requestColumns: [
      {
        text : 'Номер заявки',
        value: 'id',
        class: 'study-requests__head-cell',
        width: '200px',
      },
      {
        text : 'Дата заявки',
        value: 'date_request',
        class: 'study-requests__head-cell',
        width: '200px',
      },
      {
        text    : 'Организация сотрудника в ЛА',
        class   : 'study-requests__head-cell',
        sortable: false,
        value   : 'company',
        width   : '400px',
      },
      {
        text    : 'Начало обучения',
        class   : 'study-requests__head-cell',
        value   : 'study_start',
        sortable: false,
        width   : '200px',
      },
      {
        text    : 'Статус заявки',
        class   : 'study-requests__head-cell',
        value   : 'status',
        sortable: false,
        width   : '200px',
      },
    ],
    eventTypeList  : [],
    studentMenuList: [
      {label: 'Оформить заявку', value: 'request', icon: 'mdi-clipboard-text'},
    ],
    employeeMenuList: [
      {label: 'Редактировать', value: 'edit', icon: 'mdi-square-edit-outline'},
      {label: 'Удалить', value: 'delete', icon: 'mdi-trash-can'},
    ],
    events            : {},
    requests          : [],
    requestsPagination: {
      page       : 1,
      rowsPerPage: 10,
      descending : true,
      sortBy     : 'id',
    },
    totalRequests  : 0,
    requestStatuses: [],
  },
  getters: {
    get_plan_tabs          : ({planTabs}) => planTabs,
    get_plan_tab           : ({planTab}) => planTab,
    get_requests_headers   : ({requestColumns}) => requestColumns,
    get_requests           : ({requests}) => requests,
    get_total_requests     : ({totalRequests}) => totalRequests,
    get_requests_pagination: ({requestsPagination}) => requestsPagination,
    get_request_statuses   : ({requestStatuses}) => requestStatuses,
    get_employee_menu_list : ({employeeMenuList}) => employeeMenuList,
    get_student_menu_list  : ({studentMenuList}) => studentMenuList,
    get_event_type_list    : ({eventTypeList}) => eventTypeList,
    get_events             : ({events}) => events,
    get_disabled_dates     : ({disabledDates}) => disabledDates,
  },
  mutations: {
    SET_CURRENT_TAB(state, tabIndex) {
      state.planTab = tabIndex;
    },
    SET_EVENTS(state, events) {
      state.events = events;
    },
    SET_DISABLED_DATES(state, disabledDates) {
      state.disabledDates = disabledDates;
    },
    SET_EVENT_TYPES(state, eventTypes) {
      state.eventTypeList = eventTypes;
    },
    SET_REQUESTS(state, requests) {
      state.requests = requests;
    },
    SET_TOTAL_REQUESTS(state, total) {
      state.totalRequests = total;
    },
    SET_REQUEST_STATUSES(state, statuses) {
      state.requestStatuses = statuses;
    },
    SET_REQUESTS_PAGINATION(state, pagination) {
      state.requestsPagination = pagination;
    },
  },
  actions: {
    async fetch_events({commit}) {
      try {
        const currentYear = new Date().getFullYear();
        const eventsResponse = await api.studyPlan.fetchEvents({
          year: currentYear,
        });
        commit('SET_DISABLED_DATES', eventsResponse.data.disable);
        commit('SET_EVENTS', eventsResponse.data.events || {});
      } catch (e) {
        console.error(e);
        commit('SET_EVENTS', []);
        commit('SET_DISABLED_DATES', []);
      }
    },
    async create_event({dispatch}, payload) {
      const {eventType, dateStart, dateEnd, time, comment} = payload;
      try {
        await api.studyPlan.createEvent({
          start: dateStart,
          end  : dateEnd,
          type : eventType,
          time,
          comment,
        });
        await dispatch('fetch_events');
      } catch (e) {
        console.error(e);
      }
    },
    async update_event({dispatch}, payload) {
      const {eventType, dateStart, dateEnd, time, comment, id} = payload;
      try {
        await api.studyPlan.updateEvent({
          start: dateStart,
          end  : dateEnd,
          type : eventType,
          time,
          comment,
          id,
        });
        await dispatch('fetch_events');
      } catch (e) {
        console.error(e);
      }
    },
    async delete_event({dispatch}, eventId) {
      try {
        await api.studyPlan.deleteEvent({id: eventId});
        await dispatch('fetch_events');
      } catch (e) {
        console.error(e);
      }
    },
    async fetch_event_types(context) {
      const lang = context.rootGetters['profile/general/lang'];
      try {
        const eventTypesResponse = await api.studyPlan.fetchEventTypes({lang});
        context.commit('SET_EVENT_TYPES', eventTypesResponse.data || []);
      } catch (e) {
        console.error(e);
      }
    },
    async fetch_requests({commit}, {page = 1, column = '', sort= ''}) {
      try {
        const requestsResponse = await api.studyPlan.fetchRequests({
          page,
          column,
          sort,
        });
        commit('SET_REQUESTS', requestsResponse.data.requests.map((request) => ({
          id          : request.id,
          date_request: request.createdDate,
          company     : request.userCompany,
          study_start : `${request.startTime} ${request.start}`,
          status      : request.status.toString(),
          detail      : {
            fullName : request.name,
            phone    : request.phone,
            email    : request.email,
            employees: request.employees,
            company  : request.company,
            segments : request.segments,
            comment  : request.comment,
          },
        })));
        commit('SET_REQUEST_STATUSES', requestsResponse.data.statuses);
        commit('SET_TOTAL_REQUESTS', requestsResponse.data.total);
      } catch (e) {
        console.error(e);
      }
    },
    async create_request({dispatch, getters}, payload) {
      try {
        const {
          dateStart,
          phone,
          time,
          comment,
          company,
          courses,
          employees,
        } = payload;
        const params = {
          phone,
          comment,
          company,
          employees,
          start    : dateStart,
          startTime: time,
          segments : courses,
        };
        await api.studyPlan.createRequest(params);
        dispatch('fetch_requests', {
          column: getters.get_requests_pagination.sortBy || '',
          sort  : getters.get_requests_pagination.descending ? 'desc' : 'asc',
          page  : getters.get_requests_pagination.page - 1,
        });
      } catch (e) {
        console.error(e);
      }
    },
    async update_request_status({dispatch, getters}, {status, id}) {
      try {
        await api.studyPlan.updateRequestStatus({requestId: id, status});
        dispatch('fetch_requests', {
          column: getters.get_requests_pagination.sortBy || '',
          sort  : getters.get_requests_pagination.descending ? 'desc' : 'asc',
          page  : getters.get_requests_pagination.page - 1,
        });
      } catch (e) {
        console.error(e);
      }
    },
    async fetch_request_form_fields() {
      try {
        const requestFormFieldsResponse = await api.studyPlan.fetchRequestFormFields();
        return requestFormFieldsResponse.data;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
